import { connect } from 'react-redux'
import { getFromSettings } from 'src/utils/helpers'
import { getContactDetails } from './actions'
import Contact from './Contact'

const mapStateToProps = state => {
  return {
    isGetContactDetailsInProgress: state.contact.isGetContactDetailsInProgress,
    getContactDetailsResponse: state.contact.getContactDetailsResponse,
    companyData: state.contact.companyData,
    otherBranches: state.contact.otherBranches,
    csr: state.contact.csr,
    workingHours: state.contact.workingHours,
    countryIsoCode: getFromSettings(state, 'countryIsoCode'),
    timeZone: parseFloat(getFromSettings(state, 'timeZone', 0)),
    featureFlags: getFromSettings(state, 'featureFlags', []),
  }
}

const mapDispatchToProps = {
  getContactDetails,
}

export default connect(mapStateToProps, mapDispatchToProps)(Contact)
